export const faqList = [
  {
    question: '漫境的内容来源是否合法合规？',
    answer: '漫境所有展示内容均来自于正版授权渠道，我们与多家国内知名漫画版权方建立了长期合作关系，确保每一部作品都拥有完整的版权授权链。读者的每一次阅读，都是对创作者和版权方的支持。',
  },
  {
    question: '如何判断漫画内容是否适合自己阅读？',
    answer: '每部漫画作品页面均标注了详细的内容标签（如悬疑、情感、历史等）和适龄提示。您可以根据标签和简介来判断内容是否符合个人偏好。我们建议读者在阅读前仔细查看作品介绍和标签信息。',
  },
  {
    question: '漫境是否支持离线阅读？',
    answer: '目前漫境为在线平台，支持在桌面端和移动端浏览器中流畅阅读。我们正在开发PWA离线缓存功能，届时将支持在网络不佳的环境下继续阅读已加载的内容。敬请期待。',
  },
  {
    question: '如何保护读者的隐私？',
    answer: '漫境高度重视读者隐私保护。我们采用行业标准的加密技术保护您的浏览数据，不会收集不必要的个人信息。浏览记录仅保存在您的本地设备中，我们不会追踪或分享您的阅读偏好。具体请查阅我们的隐私政策页面。',
  },
  {
    question: '是否有付费内容？',
    answer: '漫境采用混合模式运营——大量精选内容免费开放阅读，部分独家授权或最新连载作品可能需要付费或订阅。所有付费内容均会在作品封面标注，确保读者在阅读前有充分知情权。我们始终致力于为读者提供高性价比的阅读体验。',
  },
  {
    question: '如何联系漫境的客服团队？',
    answer: '您可以通过关于我们页面的联系表单与我们取得联系，也可以发送邮件至 contact@manga-realm.readdy.ai。我们的客服团队工作时间为周一至周五 9:00-18:00，通常会在24小时内回复。',
  },
  {
    question: '漫境多久更新一次内容？',
    answer: '我们每周五更新作品库，包括新增连载章节、上新完结作品以及精选推荐调整。您可以订阅我们的新闻简报，第一时间获取更新通知和独家推荐内容。',
  },
];